import React, { useState, useContext } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import TranslatedString from "Components/TranslatedString";
import t from "Utils/translation";
import isSelectingText from "Utils/isSelectingText";
import DropdownMenu from "react-dd-menu";
import DetailInfo from "Components/detailInfo/DetailInfo";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import { MediaQueriesContext } from "@/App";
import { Icon, user, trash, enable, disable, more } from "Icons/index";

import cx from "classnames";

const ManagerCard = (props) => {
  const {
    status,
    domain_names,
    code,
    customer_code,
    showManager,
    firstname,
    lastname,
    is_customer_disabled,
    changeStatusDisabled = false,
    changeManagerStatus,
    delivery_domain_codes,
    delivery_account_ids,
    delete: deleteProp, // renamed to avoid naming conflict with reserved keyword
  } = props;

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const { isMediaMobile } = useContext(MediaQueriesContext);

  const toggle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  const close = () => {
    setIsMenuOpen(false);
  };

  const destroy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    deleteProp(code);
  };

  let changeStatusButton;

  if (status === "enabled") {
    changeStatusButton = (
      <li
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          changeManagerStatus(code, "disabled", is_customer_disabled);
        }}
      >
        <a>
          <Icon svg={disable} />
          <div>{t("ddMenu.disable")}</div>
        </a>
      </li>
    );
  } else {
    changeStatusButton = (
      <li
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          changeManagerStatus(code, "enabled", is_customer_disabled);
        }}
      >
        <a>
          <Icon svg={enable} />
          <div>{t("ddMenu.enable")}</div>
        </a>
      </li>
    );
  }

  return (
    <div
      className="flex items-baseline gap-3 px-2 py-1 mb-4 bg-white border border-solid rounded-lg cursor-pointer min-h-32 border-neutral-100"
      onClick={() => {
        if (!isSelectingText()) {
          showManager(code, customer_code);
        }
      }}
    >
      <div
        className={cx("w-6 h-6 rounded-full flex items-center justify-center", {
          ["bg-[--green]"]: status === "enabled",
          ["bg-[--yellow]"]: status === "disabled",
        })}
      >
        <Icon className="icon-stroke-white" svg={user} width="0.75rem" height="0.75rem" />
      </div>

      <div className="flex flex-col">
        <div className="text-lg font-semibold text-ellipsis whitespace-nowrap">{`${firstname} ${lastname}`}</div>

        <div className="flex flex-col">
          <DetailInfo label={t("detailInfo.label.code")} info={code} inLine />
          <DetailInfo label={t("detailInfo.label.customerCode")} info={customer_code} inLine />
          {domain_names && domain_names.length > 0 && (
            <DetailInfo label={t("detailInfo.label.domains")} info={domain_names ? domain_names.length : 0} inLine />
          )}

          {delivery_domain_codes && delivery_domain_codes.length > 0 && (
            <DetailInfo
              label={t("detailInfo.label.deliveryDomains")}
              info={delivery_domain_codes ? delivery_domain_codes.length : 0}
              inLine
            />
          )}

          {delivery_account_ids && delivery_account_ids.length > 0 && (
            <DetailInfo
              label={t("detailInfo.label.deliveryAccounts")}
              info={delivery_account_ids ? delivery_account_ids.length : 0}
              inLine
            />
          )}
        </div>
      </div>

      <div className="flex justify-end flex-grow">
        <DropdownMenu
          animate={false}
          isOpen={isMenuOpen}
          close={close}
          toggle={<ButtonIcon icon={more} onClick={toggle} />}
          align="right"
        >
          {!changeStatusDisabled && changeStatusButton}
          <li onClick={destroy}>
            <a>
              <Icon svg={trash} />
              <div>{t("ddMenu.delete")}</div>
            </a>
          </li>

          {isMediaMobile && (
            <li className="cancelBtn">
              <a>
                <div>{t("ddMenu.cancel")}</div>
              </a>
            </li>
          )}
        </DropdownMenu>
      </div>
    </div>
  );
};

export default ManagerCard;
// ManagerCard.contextTypes = ContextTypes;
